import ContentPageTemplate from '@/components/ContentPageTemplate';
import { marketingPages } from '@/data/marketingPages';

export default function AboutUsPage() {
  return <ContentPageTemplate page={marketingPages['about-us']} />;
}
